// @ts-ignore
import { createComponent } from '../helpers/create-component';
// @ts-ignore
// import { Toast } from '../index';
// New ui toast
import Toast from '../components-new/Toast.vue';

import { watch } from 'vue';

export interface ToastOptions {
    type: 'success' | 'error' | 'info' | 'progress';
    textOnClose?: string;
    duration?: number;
    message?: string;
    title?: string;
    hideOnRouteChange?: boolean;
    action?: { label: string; callback: () => void };
}

export const DEFAULT_TOAST_OPTIONS: ToastOptions = {
    type: 'info',
    textOnClose: 'Dismiss',
    duration: 5000,
    hideOnRouteChange: true
};

export type DismissFunc = () => void;
export type ToastDismissHandler = { dismiss: DismissFunc } | undefined;

const open = (options: Partial<ToastOptions>): ToastDismissHandler => {
    if (!options?.message) {
        return;
    }

    const props: ToastOptions = { ...DEFAULT_TOAST_OPTIONS, ...options };
    const instance = createComponent(
        Toast,
        props as Record<string, any>,
        document.body,
        undefined,
        'toast'
    );

    const dismiss = () => {
        (instance?.refs?.toast as Element)?.parentElement?.remove();
    };

    setTimeout(dismiss, props.duration);

    if (props?.hideOnRouteChange) {
        const unwatch = watch(
            () => window.location.href,
            () => {
                dismiss();
                unwatch();
            }
        );
    }

    return {
        dismiss
    };
};

const success = (
    message: string,
    options?: Pick<
        ToastOptions,
        'duration' | 'hideOnRouteChange' | 'action' | 'textOnClose' | 'title'
    >
) => {
    return open({
        ...options,
        message,
        type: 'success'
    });
};

const error = (
    message: string,
    options?: Pick<
        ToastOptions,
        'duration' | 'hideOnRouteChange' | 'action' | 'textOnClose' | 'title'
    >
) => {
    return open({
        ...options,
        message,
        type: 'error'
    });
};

const progress = (
    message: string,
    options?: Pick<
        ToastOptions,
        'duration' | 'hideOnRouteChange' | 'action' | 'textOnClose' | 'title'
    >
) => {
    return open({
        ...options,
        message,
        type: 'progress'
    });
};

const info = (
    message: string,
    options?: Pick<
        ToastOptions,
        'duration' | 'hideOnRouteChange' | 'action' | 'textOnClose' | 'title'
    >
) => {
    return open({
        ...options,
        message,
        type: 'info'
    });
};

export const useToast = () => {
    return {
        open,
        success,
        progress,
        error,
        info
    };
};
